import React, {useEffect, useState} from "react";
import {Route, Routes, useLocation, useNavigate} from 'react-router-dom';

import { TransitionGroup, CSSTransition } from "react-transition-group";
import 'bootstrap/dist/css/bootstrap.min.css';
import RestrictedRoute from "./toolkit/RestrictedRoute";
import Landing from "./pages/Landing";
import Subscription from "./pages/Subscription";

import Layout from "./Layout";
import TimeoutIdleTimer from "./toolkit/TimeoutIdleTimer";

import {Sanctum} from "react-sanctum";
import sanctumConfig from "../config/sanctum";
import Summary from "./pages/Summary";
import Success from "./pages/Success";
import Lounge from "./pages/Lounge";
import {useAppUniqueToken} from "../hooks/useAppUniqueToken";

import '../i18n/config';
import SubscriptionComplete from "./pages/SubscriptionComplete";
import MaintenanceModeModal from "./modals/MaintenanceModeModal";

import {maintenanceMode} from "../config/global";


const App = () => {
    let navigate = useNavigate();

    const location = useLocation();
    //console.log("HOME - location", location);
    const [transitionName, setTransitionName] = useState("fade");

    //console.log("HOME authenticated", authenticated);
    //if(authenticated && location.pathname === '/landing')
    //{
    //    console.log("HOME FORCE navigation");
    //    navigate('/');
    //}
/*
    const { checkAppUniqueTokenOnStartup } = useAppUniqueToken();
    useEffect(() => {
        console.log('App - useEffect -> checkAppUniqueTokenOnStartup: '+ location.pathname);
        checkAppUniqueTokenOnStartup(location.pathname);
    }, []);
*/
    return (
        <Sanctum config={sanctumConfig} checkOnInit={false}>
        <Layout path={location.pathname}>
            <TransitionGroup component={null}>
                <CSSTransition  key={location.pathname}
                                classNames={transitionName}
                                timeout={500}>

                    <Routes location={location}>
                        <Route path='/landing' element={<Landing /> } />
                        <Route path='/' element={<RestrictedRoute path={location.pathname}/>}>
                            <Route path='/' element={<SubscriptionComplete />}/>
                        </Route>
                        <Route path='/summary' element={<RestrictedRoute path={location.pathname}/>}>
                            <Route path='/summary' element={<Summary />}/>
                        </Route>
                        <Route path='/success' element={<RestrictedRoute path={location.pathname}/>}>
                            <Route path='/success' element={<Success />}/>
                        </Route>
                        <Route path='/lounge' element={<RestrictedRoute path={location.pathname}/>}>
                            <Route path='/lounge' element={<Lounge />}/>
                        </Route>
                    </Routes>

                </CSSTransition>
            </TransitionGroup>
        </Layout>
        <MaintenanceModeModal show={maintenanceMode} />
        </Sanctum>
    );
};
export default App;

/*
*
* <Layout path={location.pathname}>
            <TransitionGroup component={null}>
                <CSSTransition  key={location.pathname}
                                classNames={transitionName}
                                timeout={500}>

                    <Routes location={location}>
                        <Route path='/landing' element={<Landing /> } />
                        <Route path='/' element={<RestrictedRoute path={location.pathname}/>}>
                            <Route path='/' element={<Subscription />}/>
                        </Route>
                        <Route path='/summary' element={<RestrictedRoute path={location.pathname}/>}>
                            <Route path='/summary' element={<Summary />}/>
                        </Route>
                        <Route path='/success' element={<RestrictedRoute path={location.pathname}/>}>
                            <Route path='/success' element={<Success />}/>
                        </Route>
                        <Route path='/lounge' element={<RestrictedRoute path={location.pathname}/>}>
                            <Route path='/lounge' element={<Lounge />}/>
                        </Route>
                    </Routes>

                </CSSTransition>
            </TransitionGroup>
        </Layout>
* */
